import { el } from 'redom';

import serverInterface from 'server-interface';

import SingleSelectNative from 'generics/components/single-select/native';

import { getIndicesByPropertyValues } from 'utilities/collection';

import './index.scss';

class FieldSelector {

  constructor(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;
    this.onChange = configuration.onChange;
    this.collection = configuration.collection;
    this.view = configuration.view;

    this.fieldsSelectInput = new SingleSelectNative(this.buildFieldsSelectInputOptions());

    this.el = el('.data-collection-field-selector-main', [
      this.label = el('label.side-value-control-label.field-label', 'Database fields to display'),
      this.fieldsSelectInput
    ]);

  }

  handleSelectionChange({ values }) {

    let displayedColumns = null;

    if (values.length === 0) {
      const column = this.collection.columns[0];
      displayedColumns = [column];
      this.fieldsSelectInput.setValue(column._id);
    } else {
      displayedColumns = this.collection.columns.filter(function filter(column) {
        return values.includes(column._id);
      });
    }

    const data = displayedColumns.map(function mapper(column) {
      return {
        _id: column._id,
        name: column.name,
        type: column.type
      };
    });

    serverInterface.startup.dataCollectionViews.updateDataCollectionViewColumnsById(this.view._id, data);
    this.onChange();

  }

  buildFieldsSelectInputOptions() {

    const options = {
      multiSelect: true,
      onChange: this.handleSelectionChange.bind(this),
      placeholder: 'Select fields',
      labelFieldName: 'name',
      valueFieldName: '_id',
      options: this.collection.columns || [],
      selectedOptionIndices: getIndicesByPropertyValues(this.collection.columns || [], '_id', this.view.columns.map(function mapper(column) {
        return column._id;
      }))
    };

    return options;

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;

  }

}

export default FieldSelector;